import React, {useEffect, useState} from "react";
import "./userDetail.style.scss";
import {get, responseValidator} from "../../../api";
import {toast} from "react-toastify";
import Loading from "../../../loading/loading.index";
import {Button, Card, Typography} from "antd";
import BankCart from "../../UserPanel/addCard/cart/cart.index";

const {Text, Link} = Typography;
export default function UserDetail() {
    const [id, setId] = useState(null);
    // const [loading, setLoading] = useState(true)
    const [data, setData] = useState(null);
    useEffect(() => {
        setId(window.location.pathname.split("/")[3]);
        get('/AuthSurvey/user/' + window.location.pathname.split("/")[3]).then((res) => {
            if (responseValidator(res.status))
                setData(res.data.data)
            else if (res.data.message)
                toast.error(res.data.message)

        })
    }, [])
    if (!data)
        return <Loading/>
    return (
        <div className='temx-user-detail-page'>
            <Card title={<div style={{display:'flex',alignItem:'center'}} className='card-title'>
                <p>جزئیات حساب کاربری</p>
                <span style={{flex:'1'}}/>
                <Button onClick={()=>window.location.replace('/adminpanel/usermanagement')} type='link'>بازگشت به لیست</Button>
            </div>}>
                {data.mobileNumber &&
                <React.Fragment>
                    <div className="user-info-div">
                        <p className="user-info">شماره موبایل : </p>
                        <h4>
                            {data.mobileNumber}
                        </h4>
                    </div>

                </React.Fragment>
                }
                {data.firstName &&
                <React.Fragment>
                    <hr/>
                    <div className="user-info-div">
                        <p className="user-info">نام : </p>
                        <h4>
                            {data.firstName}
                        </h4>
                    </div>

                </React.Fragment>
                }
                {data.lastName &&
                <React.Fragment>
                    <hr/>
                    <div className="user-info-div">
                        <p className="user-info">نام خانوادگی: </p>
                        <h4>
                            {data.lastName}
                        </h4>
                    </div>

                </React.Fragment>
                }
                {data.natinalCode &&
                <React.Fragment>
                    <hr/>
                    <div className="user-info-div">
                        <p className="user-info">کد ملی: </p>
                        <h4>
                            {data.natinalCode}
                        </h4>
                    </div>

                </React.Fragment>
                }
                {data.birthDate &&
                <React.Fragment>
                    <hr/>
                    <div className="user-info-div">
                        <p className="user-info">تاریخ تولد : </p>
                        <h4>
                            {data.birthDate ? new Date(data.birthDate).toLocaleDateString('fa') : 'تنظیم نشده است'}
                        </h4>
                    </div>

                </React.Fragment>
                }
                {data.registerDate &&
                <React.Fragment>
                    <hr/>
                    <div className="user-info-div">
                        <p className="user-info">تاریخ عضویت : </p>
                        <h4>
                            {data.registerDate ? new Date(data.registerDate).toLocaleDateString('fa') : 'تنظیم نشده است'}
                        </h4>
                    </div>

                </React.Fragment>
                }
                {data.emailConfirmed &&
                <React.Fragment>
                    <hr/>
                    <div className="user-info-div">
                        <p className="user-info">ایمیل : </p>
                        <h4>
                            {data.email}
                        </h4>
                        <span/>
                        <label>{data.emailConfirmed ? 'تایید شده' : 'تایید نشده'}</label>
                    </div>

                </React.Fragment>
                }
                {data.landlineNumber &&
                <React.Fragment>
                    <hr/>
                    <div className="user-info-div">
                        <p className="user-info">شماره تلفن ثابت : </p>
                        <h4>
                            {data.landlineNumber}
                        </h4>
                        <span/>
                        <label>{data.landlineNumberConfirmed ? <p style={{color: 'green'}}>تایید شده</p> :
                            <Text type="warning">تایید نشده</Text>}</label>
                    </div>
                </React.Fragment>
                }
                {data.bankAccounts &&
                <React.Fragment>
                    <hr/>
                    <p style={{fontSize: '16px', marginBottom: '10px'}}>لیست حساب ها : </p>
                    {data.bankAccounts.map((item, index) => <BankCart data={item}/>)}
                </React.Fragment>}
                {data.authDocuments.length !== 0 &&
                <React.Fragment>
                    <hr/>
                    <p style={{fontSize: '16px', marginBottom: '10px'}}>لیست مدارک : </p>
                    {data.authDocuments.map((item, index) => (<div key={index} className='document'>
                        <hr/>
                        <div className='title'>
                            <p style={{
                                fontSize: '15px',
                                marginBottom: '10px'
                            }}> {item.type.title}</p>
                            <span/>
                            <label
                                className={item.state.id === 1 ? 'accept' : item.state.id === 0 ? 'pending' : 'error'}>{item.state.id === 1 ?
                                <p>تایید شده</p> : item.state.id === 0 ?
                                    <p>در انتظار تایید</p> :
                                    <p>تایید نشده</p>}</label>
                        </div>
                        <div className='image-container'>
                            {item.media.contentType.includes('image') ?
                                <img src={
                                    `data:${item.media.contentType};base64,` + item.media.fileByteContent
                                }/>
                                : <video controls={true} src={
                                    `data:${item.media.contentType};base64,` + item.media.fileByteContent
                                }/>
                            }
                        </div>

                    </div>))}
                </React.Fragment>
                }

            </Card>
        </div>
    );
}


